/*
 * @Author: cc
 * @LastEditTime: 2025-02-21 09:28:04
 */
import { useEffect, useState } from "react";
import { Table, Space, Pagination, Button } from "antd";
import { post } from "../../../common/fetch";
import { connect } from "react-redux";
import { InvoinceModal } from "./invoiceModal";
interface NoteListProps {
  // 订单ID
  id: number;
  // 用户ID 
  userId: number;
  // 机构ID
  instituteId: string;
  // 订单类型
  type: number;
  // 项目ID
  projectId: number;
  // 课程ID
  courseId: number;
  // 章节ID
  sectionId: number;
  // 订单内容
  content: string;
  // 来源系统
  sourceSystem: number;
  // 项目名称
  projectName: string;
  // 课程名称
  courseName: string;
  // 章节名称
  sectionName: string;
  // 更新时间
  updateTime: string;
  // 订单详情信息
  orderDetailInfo: string;
  // 发票申请状态
  receiptApplyStatus: number;
}
function MyOrder(props: any) {
  const {
    projectType: { type },
  } = props;
  const [totalSize, setTotalSize] = useState(1);
  const [page, setPage] = useState(1);
  const [orderInfo, setOrderInfo] = useState({});
  const [showInvoinceModal, setShowInvoinceModal] = useState(false);
  const columns = [
    {
      title: "订单编号",
      dataIndex: "tradeNo",
      key: "tradeNo",
    },
    {
      title: "资源名称",
      key: "orderDetailInfo",
      render: (text: string, record: NoteListProps) => (
        <Space size="middle">
          <p
            dangerouslySetInnerHTML={{
              __html: record?.orderDetailInfo,
            }}
          ></p>
        </Space>
      ),
    },
    {
      title: "价格",
      dataIndex: "orderAmount",
      key: "orderAmount",
    },
    {
      title: "下单时间",
      dataIndex: "orderCreateTimeText",
      key: "orderCreateTimeText",
    },
    {
      title: "订单状态",
      dataIndex: "tradeStatusDesc",
      key: "tradeStatusDesc",
    },
    // {
    //   title: "操作",
    //   key: "action",
    //   render: (text: string, record: NoteListProps) => (
    //     <Space size="middle">
    //       <Button
    //         onClick={() => {
    //           setOrderInfo(record);
    //           setShowInvoinceModal(true);
    //         }}
    //         type="link"
    //         disabled={record.receiptApplyStatus === 1}
    //       >
    //         申请发票
    //       </Button>
    //     </Space>
    //   ),
    // },
  ];
  const [trainList, setTrainList] = useState<NoteListProps[]>([]);
  const getCourseOrder = (page: number) => {
    post(
      `/shop/front/commodity/user/order/list`,
      {
        currentPage: page,
        pageSize: 6,
      },
      true
    ).then((res) => {
      const { itemOrderList, page } = res.data;
      const { totalResultSize } = page;
      const list = itemOrderList.map((item: NoteListProps, index: number) => {
        return {
          key: (page.currentPage - 1) * page.pageSize + (index + 1),
          ...item,
        };
      });
      setTrainList(list);
      setTotalSize(totalResultSize);
    });
  };
  useEffect(() => {
    getCourseOrder(1);
  }, []);
  return (
    <div>
      <Table
        columns={columns}
        dataSource={trainList}
        pagination={false}
      ></Table>
      <div style={{ textAlign: "right", padding: "20px 0" }}>
        <Pagination
          total={totalSize}
          current={page}
          hideOnSinglePage={true}
          defaultPageSize={6}
          showSizeChanger={false}
          onChange={(page) => {
            getCourseOrder(page);
            setPage(page);
          }}
        />
      </div>
      <InvoinceModal
        showInvoinceModal={showInvoinceModal}
        setShowInvoinceModal={setShowInvoinceModal}
        orderInfo={orderInfo}
        getList={getCourseOrder}
      />
    </div>
  );
}
const getProjectType = (state: {
  projectType: { type: number; activityId?: string };
}) => {
  return {
    projectType: state.projectType,
  };
};
export default connect(getProjectType)(MyOrder);
